import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

class LoadingHup extends React.Component {

    state = {}


    render() {

        return (
            <Row>
                <Col>
                    <div className="Wrapper" >
                        <div className="loader">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>

                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
};

const mapAppStateToProps = (state) => (
    {

    });


export default connect(mapAppStateToProps, {})(LoadingHup);